export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/~/d3-axis/src/array.js
// module id = ../../../../d3-axis/src/array.js
// module chunks = 3